<template>
  <Dialog :title="title" :cancel="null" :confirm="confirm" data-testid="stay-deletion-blocked-dialog" @close="(value) => $emit('close', value)">
    <template #content>
      <p>Forløbet kan ikke slettes af følgende grunde:</p>
      <ul class="list-disc list-inside mt-2">
        <li v-for="blocker in blockedBy" :key="blocker.code">{{ blocker.message }}</li>
      </ul>
    </template>
    <template #buttons>
      <BaseButton primary size="lg" @click="$emit('close', true)">
        {{ confirm }}
      </BaseButton>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "~/components/dialogs/Dialog";

export default {
  components: { Dialog },

  props: {
    blockedBy: { type: Array, required: true },
    title: { type: String, default: "Forløbet kan ikke slettes" },
    confirm: { type: String, default: "OK" },
  },

  emits: ["close"],
};
</script>
